import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Controller } from '../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../styles/Styles';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { Breadcrumbs } from '../components/Breadcrumbs'
import { BreadcrumbsHelper } from '../helpers/BreadcrumbsHelper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';

export class ActionHeaderbar extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() { }


  sliderFunction = (e) => {
    let value = 0;
    if (e === 0) {
      value = 12
    } else if (e === 1) {
      value = 6
    } else if (e === 2) {
      value = 4
    } else if (e === 3) {
      value = 3
    } else {
      value = 2
    }

    this.props.setColNumber(value)
  }

  slider = () => {
    return (
      <div className={css(Styles.formControlSwitch)}>
        <Slider
          min={0}
          max={4}
          defaultValue={1}
          step={1}
          className={css(Styles.sliderContainer)}
          railStyle={{ backgroundColor: '#3F4450', height: 4, opacity: .38 }}
          trackStyle={{ backgroundColor: '#3F4450', height: 4, opacity: 1 }}
          handleStyle={{
            borderColor: '#fafafa',
            height: 11,
            width: 11,
            marginLeft: 0,
            marginTop: -3,
            backgroundColor: '#fafafa',
            boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)'
          }}
          onChange={this.sliderFunction}
        />
      </div>
    )
  }

  renderPicker = () => {
    if (this.props.showPicker && this.props.pickerItem) {
      return (
        <FormControl>
          <Select
            name={this.props.pickerItem.key}
            className={css(Styles.pickerInnerContainer)}
            value={this.props.pickerItem.value}
            onChange={this.props.onPickerSelect}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left'
              },
              getContentAnchorEl: null,
              classes: {
                paper: css(CommonStyles.menuItemContainerRoot),
                list: css(CommonStyles.menuItemListContainerRoot)
              }
            }}
            input={
              <Input
                disableUnderline={true}
              />
            }
            classes={{
              selectMenu: css(Styles.selectOrgMenu),
              icon: css(Styles.selectIcon),
            }}
          >
            {this.props.pickerItem.options.map(item => {
              return (
                <MenuItem
                  value={item.key}
                  key={item.key}
                  className={css(CommonStyles.menuItemContainer)}>
                  <p className={css(CommonStyles.margin)}>{item.name}</p>
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      )
    }
  }

  render() {
    return (
      <div className={css(CommonStyles.outerHeaderContainer)}>
        <div className={css(CommonStyles.innerHeaderContainer)}>
          <div className={css(CommonStyles.innerHeaderFirstContainer)}>
            {this.props.backPathName &&
              <Link
                to={{ pathname: this.props.backPathName }}
                className={css(Styles.link)}>
                <div className={css(CommonStyles.headerMemberAddContainer, CommonStyles.backButton)} >
                  <img src={require('../assets/images/back-img.svg')} className={css(CommonStyles.addImg)} />
                  <p className={css(CommonStyles.margin)}>BACK</p>
                </div>
              </Link>
            }

            {this.renderPicker()}

            {this.props.camLiveIndicator && window.innerWidth > 768 &&
              <div className={css(Styles.liveTitleContainer)}>
                <p className={css(CommonStyles.paragraphMargin)}>LIVE</p>
                <div className={css(Styles.liveTitleDotContainer)} />
              </div>
            }
            <div className={css(CommonStyles.headerOrgOuterContainer, Styles.headerOrgOuterContainer)}>
              <p className={css(CommonStyles.headerMemberCountContainer)}>{this.props.title}</p>
              {this.props.breadcrumbs &&
                <Breadcrumbs items={this.props.breadcrumbs} />
              }
            </div>
          </div>
          <div className={css(CommonStyles.headerMemberOuterContainer)}>
            {this.props.fullScreen &&
              <div className={css(CommonStyles.headerMemberAddContainer, CommonStyles.headerMemberStyle, CommonStyles.headerMemberMobileStyle)}
                onClick={() => this.props.setFullscreen()}>
                <img src={require('../assets/images/fullscreen-img.svg')} className={css(CommonStyles.addImg)} />
                {this.props.fullScreenMode}
              </div>
            }
            {this.props.slider &&
              <div className={css(CommonStyles.headerMemberAddContainer, CommonStyles.headerMemberStyle, CommonStyles.headerMemberMobileStyle)} >
                <img src={require('../assets/images/grid-img2.svg')} className={css(CommonStyles.addImg, Styles.gridImg)} />
                {this.slider()}
                <img src={require('../assets/images/grid-img1.svg')} className={css(CommonStyles.addImg, Styles.gridImg)} />
              </div>
            }
            {this.props.statPrefix && this.props.statSuffix &&
              <div className={css(CommonStyles.headerMemberOuterMobileStyle)}>
                <p className={css(CommonStyles.headerMemberCountContainer)}>{this.props.statPrefix}  |  {this.props.items.length} {this.props.statSuffix}</p>
              </div>
            }
            {this.props.statPrefix && !this.props.statSuffix &&
              <div className={css(CommonStyles.headerMemberOuterMobileStyle)}>
                <p className={css(CommonStyles.headerMemberCountContainer)}>{this.props.items.length} {this.props.statPrefix}</p>
              </div>
            }
            {(Controller.get().userMgr().isProductUser() || Controller.get().userMgr().isAdminUser()) && this.props.buttonOneTitle &&
              <div className={css(CommonStyles.headerMemberAddContainer)} onClick={() => this.props.buttonOneAction()}>
                <img src={require('../assets/images/add-img.svg')} className={css(CommonStyles.personAddIcon)} />
                <p className={css(CommonStyles.margin)}>{this.props.buttonOneTitle}</p>
              </div>
            }
            {(Controller.get().userMgr().isProductUser() || Controller.get().userMgr().isAdminUser()) && this.props.buttonTwoTitle && window.innerWidth > 768 &&
              <div className={css(CommonStyles.headerMemberOuterMobileStyle)}>
                <Button
                  disabled={this.props.inProcess}
                  variant='contained'
                  onClick={e => this.props.buttonTwoAction()}
                  className={css(Styles.buttonStyle, Styles.buttonStyleUpload)}>
                  {this.props.buttonTwoTitle}
                </Button>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ActionHeaderbar.js